// アプリケーションバージョン
// メジャーチェンジ: +0.5 / マイナーチェンジ: +0.2
// ※デプロイ前に必ずこの番号を手動で更新すること（管理者・顧客・ログイン画面に表示され、目線合わせに使用）
// 1.9 (2026-08-29): 発注控え印刷が2ページになる問題を修正（印刷はレイアウト外ポータルで出力し1日=1ページに）
// 1.7 (2026-08-29): 発注控え印刷の白紙出力を修正
// 1.5 (2026-08-29): 締切JST判定修正・幻の「変更あり」修正・サポートページ追加・全発注データを顧客選択→期間選択に刷新
export const APP_VERSION = "1.9";
export const APP_NAME = "やさまるポータル";
